import { overviewFeatures, overviewHighlights } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Overview() {
  return (
    <section id="overview" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="Overview"
          title="先说清楚：这一页到底是什么"
          desc="它不是某个单一作品的入口，而是一份围绕《年轻的岳母》整理的阅读索引——把题材定位、内容形态与查找方式集中放在同一页，让你打开就能判断该从哪里开始。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-7 order-2 lg:order-1">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {overviewFeatures.map((feat) => (
                <article
                  key={feat.title}
                  className="p-5 rounded-lg bg-background-100 border border-background-200 flex flex-col gap-3"
                >
                  <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                    <i className={`${feat.icon} text-xl`} />
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{feat.title}</h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{feat.desc}</p>
                </article>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 order-1 lg:order-2">
            <div className="rounded-lg overflow-hidden border border-background-200 bg-background-100">
              <div className="w-full h-56 md:h-64">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20painterly%20illustration%20of%20a%20cozy%20reading%20corner%20with%20stacked%20art%20books%2C%20a%20warm%20desk%20lamp%20glow%2C%20muted%20terracotta%20ochre%20and%20sage%20palette%2C%20soft%20canvas%20texture%2C%20minimal%20calm%20composition%2C%20no%20text%2C%20no%20people&width=1000&height=800&seq=overview-reading-corner-01&orientation=landscape"
                  alt="阅读角落示意图"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">一眼能看懂的四个关键信息</h3>
                <dl className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
                  {overviewHighlights.map((item) => (
                    <div key={item.label}>
                      <dt className="text-xs text-foreground-500">{item.label}</dt>
                      <dd className="mt-0.5 text-sm font-medium text-foreground-900">{item.value}</dd>
                    </div>
                  ))}
                </dl>
                <p className="mt-4 text-xs leading-relaxed text-foreground-500">
                  * 页面内容为演示用整理条目，用于说明阅读场景的组织方式。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}